import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ENGINE_METADATA_PROVIDER } from 'src/engine-sdk/contract/metadata';
import { EngineMetadataProvider } from './services/engine-metadata-provider.service';

export function provideEngineMetadata(): EnvironmentProviders {
  return makeEnvironmentProviders([
    EngineMetadataProvider,
    { provide: ENGINE_METADATA_PROVIDER, useExisting: EngineMetadataProvider },
  ]);
}
